import React from "react";

import ScrollSync from "components/ScrollSync";
import NoContent from "components/NoContent";
import Loader from "components/Loader";
import TableHeader from "./TableHeader";
import TableContent from "./TableContent";
import TableFooter from "./TableFooter";
import { useRacehorse360Api } from "hooks/api";
import useStyles from "./styles";

const InventoryAnalytics = () => {
  const classes = useStyles();

  const { usePullInventoryAnalytics } = useRacehorse360Api();

  const { data: inventoryAnalyticsResponse, isLoading: isDataLoading } =
    usePullInventoryAnalytics({});
  const data = inventoryAnalyticsResponse?.chart || [];

  if (isDataLoading) return <Loader />;

  if (!data.length) return <NoContent />;

  return (
    <div className={classes.root}>
      <ScrollSync enabled={true}>
        <TableHeader />

        <TableContent data={data} />

        <TableFooter data={data} />
      </ScrollSync>
    </div>
  );
};

export default InventoryAnalytics;
